// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__otd3Z","container":"style_container__1AtBP","cards":"style_cards__27K9j","content":"style_content__3jaEd"};